import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPage, getUser } from "selectors/commonSelectors";
import { filterCollabStatus } from "actions/postsView";
import { PAGES } from "constants/Pages";

import StatusChange from "components/Collaboration/StatusChange/StatusChange";
import { FormSize } from "ui/ecosystems/forms";

interface CollabStatusDropdownProps {
  onChange?: (value: string) => void;
  postStatusKey?: string;
  selectDefault?: boolean;
  triggerClassName?: string;
}

const CollabStatusDropdown: React.FC<CollabStatusDropdownProps> = ({
  onChange,
  postStatusKey = "",
  selectDefault = false,
  triggerClassName,
}) => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const page = useSelector(getPage) || "";

  if (!user) {
    return null;
  }

  const onStatusChange = (ddItem: string) => {
    if (!onChange) {
      switch (page) {
        case PAGES.UPCOMING: {
          break;
        }
        case PAGES.DRAFT: {
          break;
        }
        default: {
          throw new Error(`Not able to change post status for page ${page}`);
        }
      }
      dispatch(filterCollabStatus(ddItem ? [ddItem] : null));
    }
    if (onChange) {
      onChange(ddItem);
    }
  };

  return (
    <StatusChange
      size={FormSize.small}
      selectedStatusKey={postStatusKey}
      isClearable={true}
      placeholder={"Show only posts with status…"}
      onChange={onStatusChange}
      selectDefault={selectDefault}
      triggerClassName={triggerClassName}
    />
  );
};

export default CollabStatusDropdown;
